import { push } from 'connected-react-router';
import qs from 'query-string';

import { getCurrentPathParams } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { parseMarketingParams } from 'src/app/utils';

import { SET_CURRENT_ROUTER_LOCATION } from './onBoardingActions';

export function setCurrentRouterLocation(currentRouterLocation) {
  return {
    type: SET_CURRENT_ROUTER_LOCATION,
    currentRouterLocation,
  };
}

/**
 * React router push that preserves current query params
 * @param path string
 * @returns
 */
export function pushWithQueryParams(path: string, additionalQuery: { [key: string]: string } = {}) {
  return (dispatch: Dispatch, getState: () => RootState) => {
    const state = getState();
    const pathParams = getCurrentPathParams(state);
    const marketingParams = parseMarketingParams(pathParams);

    const combinedParams = {
      ...marketingParams,
      ...additionalQuery,
    };

    dispatch(
      push({
        pathname: path,
        search: `?${qs.stringify(combinedParams)}`,
      })
    );
  };
}
